import { combineReducers } from 'redux'
import { reducer as toastrReducer } from 'react-redux-toastr'
import { reducer as formReducer } from 'redux-form'

import authreducer from './authReducer'
import usrreducer from './usrReducer'

const reducersApp = combineReducers({
    authreducer,
    toastr: toastrReducer,
    form: formReducer,
    usrreducer
})

export default reducersApp